import { createGlobalStyle } from "styled-components";
import { setColor } from "./Styles";

const Globals = createGlobalStyle`

*{
 margin:0;
 padding:0;
 box-sizing:border-box;
}

`;

export default Globals;
